import { OrderStatus } from '../../orders-new/models/order.dto';
import { BomStructure } from '../../../../models/bom-structure';
import { TYPE_LABELS } from '../../../tree-summary/tree-summary.component';

/**
 * GET /production/material-requirements (0118, reshaped by 0122): the zlecenia whose planned
 * window touches the range (any status but Done), and every line they will produce or consume,
 * one row per snapshot line. Gross — what the zlecenia plan, regardless of what was reported.
 */
export interface MaterialRequirementsDto {
  /** By planned start, then number. */
  orders: MaterialRequirementsOrderDto[];
  /** By zlecenie as orders is ordered; inside one, each position's tree depth-first, as DRZEWO shows it. */
  rows: MaterialRequirementRowDto[];
}

export interface MaterialRequirementsOrderDto {
  orderId: number;
  orderNumber: string;
  name: string;
  /** "2026-10-20", a calendar day. */
  plannedStartDate: string;
  plannedEndDate: string;
  status: OrderStatus;
}

/**
 * One snapshot line of a counted zlecenie (0122), named in the zlecenie's frozen words — nothing
 * summed: the same item in two zlecenia, or in two positions of one, is two rows. What sits under
 * a purchased line is not a row, as in PODSUMOWANIE (0120).
 */
export interface MaterialRequirementRowDto {
  orderId: number;
  orderNumber: string;
  orderName: string;
  orderItemId: number;
  name: string;
  /** null on a root, which the table words produkt końcowy. */
  parentName: string | null;
  /** The root's name — the root's own on a root row. */
  rootName: string;
  type: MaterialRequirementRowType;
  structure: BomStructure;
  /** The line's order total, in unit. */
  amount: number;
  unit: string;
}

// PODSUMOWANIE's rule, decided by the API: a purchased line is a material wherever it sits; else
// a root is the product, a childless line a material, anything else a półprodukt
export enum MaterialRequirementRowType {
  product,
  module,
  material
}

// PODSUMOWANIE's WG TYPU words, so Typ reads the same on the card and in the report
export const ROW_TYPE_LABELS: Record<MaterialRequirementRowType, string> = {
  [MaterialRequirementRowType.product]: TYPE_LABELS['product'],
  [MaterialRequirementRowType.module]: TYPE_LABELS['module'],
  [MaterialRequirementRowType.material]: TYPE_LABELS['material']
};

/** Do: the parent's name, or produkt końcowy on a root — Zgłoszenia's words, on screen and in the file. */
export function parentLabel(row: MaterialRequirementRowDto): string {
  return row.parentName ?? 'produkt końcowy';
}
